import { RedirectButton } from '@y42/gojs';
import { Binding, GraphObject, Margin, Panel, Spot } from 'gojs';
import { OrchestrationDiagramParts } from '../../../config/orchestration-part-names';
import {
  importTypeButtonVisibilityBinding,
  onFailureButtonVisibilityBinding,
  showLogsButtonVisibilityBinding,
} from '../utils/bindings';
import { ImportTypePlaceholder } from './buttons/import-type-button';
import { OnFailurePlaceholder } from './buttons/on-failure-buttons';
import { ShowLogsButton } from './buttons/show-logs-button';
import { DetailsPanel } from './details-panel';
import { NodeJobStatus } from './status';

const $ = GraphObject.make;

export const ContentPanel = (props: Record<string, unknown> = {}, bindings: Binding[] = []): Panel =>
  $(
    Panel,
    Panel.Auto,
    {
      name: OrchestrationDiagramParts.ContentPanel,
      padding: new Margin(5),
      stretch: GraphObject.Horizontal,
      ...props,
    },
    leftPanel(),
    rightPanel(),
    ...bindings,
  );

const leftPanel = () => $(Panel, Panel.Horizontal, { alignment: Spot.Left }, DetailsPanel());
const rightPanel = () =>
  $(
    Panel,
    Panel.Horizontal,
    { alignment: Spot.Right, margin: new Margin(0, 5, 0, 0) },
    ImportTypePlaceholder({}, [importTypeButtonVisibilityBinding()]),
    OnFailurePlaceholder({}, [onFailureButtonVisibilityBinding()]),
    NodeJobStatus(),
    ShowLogsButton({}, [showLogsButtonVisibilityBinding()]),
    RedirectButton({
      partName: OrchestrationDiagramParts.RedirectButton,
    }),
  );
